import { useEffect, useRef } from 'react';
import './ExportPreview.css';

export type ExportArtifact = { url: string; filename: string; text?: string; kind?: 'species'; imageMissing?: boolean };

/** Keep the generated artifact available when an embedded browser blocks automatic downloads. */
export default function ExportPreview({ artifact, onClose }: { artifact: ExportArtifact | null; onClose: () => void }) {
  const dialog = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    if (artifact && !dialog.current?.open) dialog.current?.showModal();
  }, [artifact]);
  if (!artifact) return null;
  return (
    <dialog className={`export-preview${artifact.kind === 'species' ? ' export-preview--species' : ''}`} ref={dialog} aria-labelledby="export-preview-title" onCancel={onClose}>
      <header><div>{artifact.kind === 'species' && <span className="export-preview-eyebrow">留住这一页自然</span>}<h2 id="export-preview-title">{artifact.text !== undefined ? '对话导出预览' : '分享卡预览'}</h2></div><button type="button" onClick={onClose} aria-label="关闭导出预览">×</button></header>
      <p>{artifact.kind === 'species' ? '原书配图 · 高清图鉴卡，适合保存与分享。' : '内容已生成。若未自动下载，可点击下方保存；手机也可长按图片保存或选择文本复制。'}</p>
      {artifact.imageMissing && <p role="status" className="export-preview-warning">原书图片未能加载，本次为文字版分享卡。可关闭后重试。</p>}
      <div className="export-preview-content">
      {artifact.text !== undefined
        ? <textarea readOnly aria-label="导出对话文本" value={artifact.text} />
        : <img src={artifact.url} alt="生成的分享卡" />}
      </div>
      <footer><span>{artifact.kind === 'species' ? '1080 × 1440 · PNG / 手机可长按保存' : ''}</span><a className="btn primary" href={artifact.url} download={artifact.filename}>保存{artifact.text !== undefined ? ' TXT 文件' : ' PNG 图片'}</a></footer>
    </dialog>
  );
}
